module.exports = __webpack_public_path__ + "img/linkedin-monochrome.9f86f91d.svg";